// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* frontend/src/components/StudentDetails.css */

.form-container {
    max-width: 600px;
    margin: 50px auto;
    padding: 20px;
    border: 1px solid #ccc;
    border-radius: 8px;
  }
  
  .details-block {
    background-color: #f9f9f9;
    padding: 15px;
    border-radius: 4px;
    margin-bottom: 20px;
  }
  
  .input-block {
    margin-bottom: 15px;
  }
  
  .input-block label {
    display: block;
    margin-bottom: 5px;
    font-weight: bold;
  }
  
  .input-block input {
    width: 100%;
    padding: 8px;
    box-sizing: border-box;
  }
  
  .button-group {
    display: flex;
    justify-content: space-between;
  }
  
  .button {
    padding: 10px 15px;
    background-color: #28a745;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
  }
  
  .button:hover {
    background-color: #218838;
  }
  
  .error {
    color: red;
    margin-bottom: 10px;
  }
  `, "",{"version":3,"sources":["webpack://./src/Components/Payments/StudentDetails/StudentDetails.css"],"names":[],"mappings":"AAAA,+CAA+C;;AAE/C;IACI,gBAAgB;IAChB,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,yBAAyB;IACzB,aAAa;IACb,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,sBAAsB;EACxB;;EAEA;IACE,aAAa;IACb,8BAA8B;EAChC;;EAEA;IACE,kBAAkB;IAClB,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,UAAU;IACV,mBAAmB;EACrB","sourcesContent":["/* frontend/src/components/StudentDetails.css */\n\n.form-container {\n    max-width: 600px;\n    margin: 50px auto;\n    padding: 20px;\n    border: 1px solid #ccc;\n    border-radius: 8px;\n  }\n  \n  .details-block {\n    background-color: #f9f9f9;\n    padding: 15px;\n    border-radius: 4px;\n    margin-bottom: 20px;\n  }\n  \n  .input-block {\n    margin-bottom: 15px;\n  }\n  \n  .input-block label {\n    display: block;\n    margin-bottom: 5px;\n    font-weight: bold;\n  }\n  \n  .input-block input {\n    width: 100%;\n    padding: 8px;\n    box-sizing: border-box;\n  }\n  \n  .button-group {\n    display: flex;\n    justify-content: space-between;\n  }\n  \n  .button {\n    padding: 10px 15px;\n    background-color: #28a745;\n    color: white;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n  }\n  \n  .button:hover {\n    background-color: #218838;\n  }\n  \n  .error {\n    color: red;\n    margin-bottom: 10px;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
